import { Pipe, PipeTransform, Inject } from '@angular/core';
import * as moment from 'moment';

// Simple translate pipe to pass through calls to angular $translate
@Pipe({
  name: 'dateTimeFormat'
})

export class DateTimeFormatPipe implements PipeTransform {
  constructor(@Inject('$translate') private $translate) {
  }

  transform(datetime: any, format: string, fromNowEnabled: boolean): string {
    if (datetime) {
      if (fromNowEnabled && moment(datetime).isSame(moment(), 'day')) {
        return moment(datetime).fromNow();
      }

      return moment(datetime).format(this.$translate.instant(`date_format.${format}`));
    }

    return datetime;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/date-time-format.pipe.ts